/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import React from 'react';
import { useTranslation } from 'react-i18next';
import { COMPONENT_SERVICE_STRINGS } from '../../../../Constants/Strings.constants';
import { ComponentDetailsProps } from '../../ComponentDetails.props';
import { ComponentDetailsVersionsBadge } from './elements/ComponentDetailsVersionsBadge/ComponentDetailsVersionsBadge';

/**
 * Component details versions.
 * @param {ComponentDetailsProps} props Component details props.
 * @export
 * @returns {JSX.Element} The `<ComponentDetailsVersions />` component.
 */
export const ComponentDetailsVersions = (props: ComponentDetailsProps): JSX.Element => {
  const { t } = useTranslation();
  const { componentVersions, selectedVersion, updateVersion } = props;

  const labels = {
    allVersionsAvailable: t(COMPONENT_SERVICE_STRINGS.allVersionsAvailable),
  };

  const versions = componentVersions.map((version: string, index: number) => {
    return (
      <ComponentDetailsVersionsBadge
        isSelected={version === selectedVersion}
        key={index}
        label={version}
        updateVersion={updateVersion}
      />
    );
  });

  return (
    <div className="component-details__versions">
      <h2>{labels.allVersionsAvailable}</h2>
      <div className="component-details__versions-row">
        <div className="component-details__versions-content">{versions}</div>
      </div>
    </div>
  );
};
